import { OhatStatus } from './status';

export class Choice {
  public constructor(
    public readonly status: OhatStatus,
    public readonly imageSrc: string,
    public readonly description: string[],
    public readonly descriptionEn: string[] = [],
  ) {}

  /** 表示言語に応じた症状説明の配列を返す。英語未整備の場合は日本語にフォールバック。 */
  getDescription(lang?: string): string[] {
    return lang?.startsWith('en') && this.descriptionEn.length > 0
      ? this.descriptionEn
      : this.description;
  }
}
